import { render, staticRenderFns } from "./AbaEditarParticipantes.vue?vue&type=template&id=bbbcaa92&scoped=true"
import script from "./AbaEditarParticipantes.vue?vue&type=script&lang=ts"
export * from "./AbaEditarParticipantes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbcaa92",
  null
  
)

export default component.exports